import React, { useEffect, Fragment } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { BsChevronLeft } from "react-icons/bs";
import Footer from "../Components/Reuseable/Footer.jsx";
import CoptRight from "../Components/Reuseable/Copyrights";
import TrainerDetail from "../Components/Modal/TrainerModal";

const TrainerDetailPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { id: paramId } = useParams();
  const cookiedata = Cookies.get("i18next");

  const id = paramId || location.search.slice(1) || location.state?.id;

  const { data: singletrainer, status } = useSelector(
    (state) => state.singletrainer
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [id]);

  const trainerName =
    singletrainer && status !== "loading"
      ? cookiedata === "en"
        ? singletrainer.NameEn || ""
        : singletrainer.NameAr || singletrainer.NameEn || ""
      : "";

  const bannerTitle = trainerName ? trainerName : t("Trainer");

  return (
    <Fragment>
      <div className="common-page-banner">
        <h1>{bannerTitle}</h1>
      </div>

      <div className="container-fluid new-main-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="new-race-detail-container col-sm-12"
                dir={cookiedata?.startsWith("ar") ? "rtl" : "ltr"}
                style={{ background: "rgb(255,255,255)", borderRadius: "10px" }}
              >
                <div
                  className="new-race-top-header-bar"
                  style={{ background: "rgb(10 31 67)" }}
                >
                  <div className="new-header-left-side">
                    <div
                      className="new-header-title-group"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                      }}
                    >
                      <BsChevronLeft
                        className="new-back-arrow"
                        onClick={() => navigate(-1)}
                        style={{ cursor: "pointer" }}
                      />
                      <h2 className="new-header-track-name">{trainerName || t("Loading...")}</h2>
                    </div>
                  </div>
                </div>

                {id ? (
                  <div style={{ padding: "10px 0" }}>
                    <TrainerDetail data={{ _id: id }} />
                  </div>
                ) : (
                  <div className="py-5 text-center">
                    <p style={{ color: "#888", fontSize: "18px" }}>
                      {t("No trainer selected.")}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <CoptRight />
    </Fragment>
  );
};

export default TrainerDetailPage;
